import React from "react";
import { X, Sparkles, Zap } from "lucide-react";

export default function PaywallModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-testid="paywall">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-md" onClick={onClose} />
      <div className="relative glass-strong rounded-3xl p-7 w-full max-w-md">
        <button data-testid="paywall-close" onClick={onClose} className="absolute top-4 right-4 text-slate-400"><X className="w-5 h-5" /></button>
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-violet-500 to-cyan-400 flex items-center justify-center shadow-lg shadow-violet-500/40 mb-4">
          <Sparkles className="w-7 h-7 text-white" />
        </div>
        <div className="text-xs uppercase tracking-[0.24em] text-violet-300 font-semibold mb-2">Free limit reached</div>
        <h3 className="text-2xl font-bold text-slate-100">Unlock AfterMind Premium</h3>
        <p className="mt-2 text-sm text-slate-400">You've used your 5 free image uploads for today. Upgrade to unlock unlimited imagery, video generation with Sora 2, AI Agents, priority processing and advanced memory.</p>
        <ul className="mt-5 space-y-2 text-sm text-slate-200">
          <li className="flex items-center gap-2"><Zap className="w-4 h-4 text-violet-300" /> Unlimited image uploads & analysis</li>
          <li className="flex items-center gap-2"><Zap className="w-4 h-4 text-violet-300" /> AfterMind Live · real-time camera</li>
          <li className="flex items-center gap-2"><Zap className="w-4 h-4 text-violet-300" /> Sora 2 video generation</li>
          <li className="flex items-center gap-2"><Zap className="w-4 h-4 text-violet-300" /> AI Agents · multi-step task execution</li>
        </ul>
        <a href="mailto:admin@aftermind.ai?subject=Request%20AfterMind%20Premium" data-testid="paywall-cta" className="aura-btn-primary block text-center mt-6 py-3.5 rounded-xl text-white font-semibold">Request Premium access</a>
        <div className="mt-3 text-xs text-slate-500 text-center">Admins can grant premium instantly.</div>
      </div>
    </div>
  );
}
